/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseConsumptionOverviewDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseDeviceDetailDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseIntervalFlowDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseObject } from '../backend/model';
// @ts-ignore
import type { ApiResponsePaginatedResponseDTODeviceDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponsePaginatedResponseDTOPlatformMeterInfoDTO } from '../backend/model';
// @ts-ignore
import type { AssignMultipleDevicesRequest } from '../backend/model';
/**
 * CouncilDeviceApi - axios parameter creator
 * @export
 */
export const CouncilDeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign a device to a user within a council
         * @summary Assign a device to a user within a council
         * @param {string} councilId 
         * @param {AssignMultipleDevicesRequest} assignMultipleDevicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDeviceToUser: async (councilId: string, assignMultipleDevicesRequest: AssignMultipleDevicesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('assignDeviceToUser', 'councilId', councilId)
            // verify required parameter 'assignMultipleDevicesRequest' is not null or undefined
            assertParamExists('assignDeviceToUser', 'assignMultipleDevicesRequest', assignMultipleDevicesRequest)
            const localVarPath = `/api/council/{councilId}/devices/assign`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignMultipleDevicesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get a specific device for a council
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilDevice: async (councilId: string, deviceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilDevice', 'councilId', councilId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getCouncilDevice', 'deviceId', deviceId)
            const localVarPath = `/api/council/{councilId}/devices/{deviceId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get devices for a specific council with filtering and pagination
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {string} [type] 
         * @param {string} [customerId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilDevices: async (councilId: string, search?: string, status?: string, type?: string, customerId?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilDevices', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/devices`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption data for a specific device
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {string} [period] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceConsumption: async (councilId: string, deviceId: string, period?: string, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getDeviceConsumption', 'councilId', councilId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getDeviceConsumption', 'deviceId', deviceId)
            const localVarPath = `/api/council/{councilId}/devices/{deviceId}/consumption`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Array<string>} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePlatforms: async (councilId: string, search?: string, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getDevicePlatforms', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/devices/platforms`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get interval flow measurement data for a specific device
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {string} from 
         * @param {string} to 
         * @param {number} [currentPage] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntervalFlow: async (councilId: string, deviceId: string, from: string, to: string, currentPage?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getIntervalFlow', 'councilId', councilId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('getIntervalFlow', 'deviceId', deviceId)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getIntervalFlow', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getIntervalFlow', 'to', to)
            const localVarPath = `/api/council/{councilId}/devices/{deviceId}/interval-flow`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }

            if (currentPage !== undefined) {
                localVarQueryParameter['currentPage'] = currentPage;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific device for a council
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncilDevice: async (councilId: string, deviceId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('updateCouncilDevice', 'councilId', councilId)
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('updateCouncilDevice', 'deviceId', deviceId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCouncilDevice', 'body', body)
            const localVarPath = `/api/council/{councilId}/devices/{deviceId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)))
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilDeviceApi - functional programming interface
 * @export
 */
export const CouncilDeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilDeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign a device to a user within a council
         * @summary Assign a device to a user within a council
         * @param {string} councilId 
         * @param {AssignMultipleDevicesRequest} assignMultipleDevicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignDeviceToUser(councilId: string, assignMultipleDevicesRequest: AssignMultipleDevicesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignDeviceToUser(councilId, assignMultipleDevicesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDeviceApi.assignDeviceToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get a specific device for a council
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilDevice(councilId: string, deviceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDeviceDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilDevice(councilId, deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDeviceApi.getCouncilDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get devices for a specific council with filtering and pagination
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {string} [type] 
         * @param {string} [customerId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilDevices(councilId: string, search?: string, status?: string, type?: string, customerId?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePaginatedResponseDTODeviceDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilDevices(councilId, search, status, type, customerId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDeviceApi.getCouncilDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption data for a specific device
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {string} [period] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceConsumption(councilId: string, deviceId: string, period?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConsumptionOverviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceConsumption(councilId, deviceId, period, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDeviceApi.getDeviceConsumption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Array<string>} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevicePlatforms(councilId: string, search?: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePaginatedResponseDTOPlatformMeterInfoDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevicePlatforms(councilId, search, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDeviceApi.getDevicePlatforms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get interval flow measurement data for a specific device
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {string} from 
         * @param {string} to 
         * @param {number} [currentPage] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIntervalFlow(councilId: string, deviceId: string, from: string, to: string, currentPage?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntervalFlowDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIntervalFlow(councilId, deviceId, from, to, currentPage, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDeviceApi.getIntervalFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific device for a council
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouncilDevice(councilId: string, deviceId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDeviceDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouncilDevice(councilId, deviceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilDeviceApi.updateCouncilDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilDeviceApi - factory interface
 * @export
 */
export const CouncilDeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilDeviceApiFp(configuration)
    return {
        /**
         * Assign a device to a user within a council
         * @summary Assign a device to a user within a council
         * @param {string} councilId 
         * @param {AssignMultipleDevicesRequest} assignMultipleDevicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignDeviceToUser(councilId: string, assignMultipleDevicesRequest: AssignMultipleDevicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseObject> {
            return localVarFp.assignDeviceToUser(councilId, assignMultipleDevicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get a specific device for a council
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilDevice(councilId: string, deviceId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDeviceDetailDTO> {
            return localVarFp.getCouncilDevice(councilId, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get devices for a specific council with filtering and pagination
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {string} [type] 
         * @param {string} [customerId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilDevices(councilId: string, search?: string, status?: string, type?: string, customerId?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePaginatedResponseDTODeviceDTO> {
            return localVarFp.getCouncilDevices(councilId, search, status, type, customerId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get consumption data for a specific device
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {string} [period] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceConsumption(councilId: string, deviceId: string, period?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConsumptionOverviewDTO> {
            return localVarFp.getDeviceConsumption(councilId, deviceId, period, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {Array<string>} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePlatforms(councilId: string, search?: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePaginatedResponseDTOPlatformMeterInfoDTO> {
            return localVarFp.getDevicePlatforms(councilId, search, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Get interval flow measurement data for a specific device
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {string} from 
         * @param {string} to 
         * @param {number} [currentPage] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntervalFlow(councilId: string, deviceId: string, from: string, to: string, currentPage?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntervalFlowDTO> {
            return localVarFp.getIntervalFlow(councilId, deviceId, from, to, currentPage, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * WARNING: This API is not yet complete and may change in future versions.
         * @summary Update a specific device for a council
         * @param {string} councilId 
         * @param {string} deviceId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncilDevice(councilId: string, deviceId: string, body: object, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDeviceDetailDTO> {
            return localVarFp.updateCouncilDevice(councilId, deviceId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilDeviceApi - object-oriented interface
 * @export
 * @class CouncilDeviceApi
 * @extends {BaseAPI}
 */
export class CouncilDeviceApi extends BaseAPI {
    /**
     * Assign a device to a user within a council
     * @summary Assign a device to a user within a council
     * @param {string} councilId 
     * @param {AssignMultipleDevicesRequest} assignMultipleDevicesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDeviceApi
     */
    public assignDeviceToUser(councilId: string, assignMultipleDevicesRequest: AssignMultipleDevicesRequest, options?: RawAxiosRequestConfig) {
        return CouncilDeviceApiFp(this.configuration).assignDeviceToUser(councilId, assignMultipleDevicesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get a specific device for a council
     * @param {string} councilId 
     * @param {string} deviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDeviceApi
     */
    public getCouncilDevice(councilId: string, deviceId: string, options?: RawAxiosRequestConfig) {
        return CouncilDeviceApiFp(this.configuration).getCouncilDevice(councilId, deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get devices for a specific council with filtering and pagination
     * @param {string} councilId 
     * @param {string} [search] 
     * @param {string} [status] 
     * @param {string} [type] 
     * @param {string} [customerId] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDeviceApi
     */
    public getCouncilDevices(councilId: string, search?: string, status?: string, type?: string, customerId?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return CouncilDeviceApiFp(this.configuration).getCouncilDevices(councilId, search, status, type, customerId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get consumption data for a specific device
     * @param {string} councilId 
     * @param {string} deviceId 
     * @param {string} [period] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDeviceApi
     */
    public getDeviceConsumption(councilId: string, deviceId: string, period?: string, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return CouncilDeviceApiFp(this.configuration).getDeviceConsumption(councilId, deviceId, period, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} councilId 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {Array<string>} [sort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDeviceApi
     */
    public getDevicePlatforms(councilId: string, search?: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig) {
        return CouncilDeviceApiFp(this.configuration).getDevicePlatforms(councilId, search, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Get interval flow measurement data for a specific device
     * @param {string} councilId 
     * @param {string} deviceId 
     * @param {string} from 
     * @param {string} to 
     * @param {number} [currentPage] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDeviceApi
     */
    public getIntervalFlow(councilId: string, deviceId: string, from: string, to: string, currentPage?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return CouncilDeviceApiFp(this.configuration).getIntervalFlow(councilId, deviceId, from, to, currentPage, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * WARNING: This API is not yet complete and may change in future versions.
     * @summary Update a specific device for a council
     * @param {string} councilId 
     * @param {string} deviceId 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilDeviceApi
     */
    public updateCouncilDevice(councilId: string, deviceId: string, body: object, options?: RawAxiosRequestConfig) {
        return CouncilDeviceApiFp(this.configuration).updateCouncilDevice(councilId, deviceId, body, options).then((request) => request(this.axios, this.basePath));
    }
}

